/**
 * Pure helpers for the self-serve "AI Dashboards" offer.
 *
 * Intentionally uses structural types (no @coeff/api imports) so this module
 * can be unit-tested without ts-jest encountering @coeff/api's compiled JS.
 */

/**
 * Dashboards included with the self-serve AI Dashboards add-on.
 * Mirrors SELF_SERVE_WEB_DASHBOARD_ADDON_LIMIT (coeff/server/lib/web_dashboard_limit_utils.py).
 */
export const SELF_SERVE_WEB_DASHBOARD_LIMIT = 5;

/**
 * Contact-sales copy for a buyer who already owns more active dashboards than the self-serve
 * add-on includes (eligibility `too_many_dashboards`). Keep in sync with
 * _too_many_dashboards_message (coeff/server/controllers/subscription_controller.py).
 */
export const getTooManyDashboardsMessage = (activeCount: number | null | undefined): string => {
  const countText =
    activeCount === null || activeCount === undefined
      ? `more than ${SELF_SERVE_WEB_DASHBOARD_LIMIT}`
      : `${activeCount}`;
  return `You have ${countText} dashboards. Self-serve AI Dashboards includes ${SELF_SERVE_WEB_DASHBOARD_LIMIT}. Contact sales for a plan that fits.`;
};

/**
 * Whether the pricing / checkout pages show the AI Dashboards offer at all: only to users who
 * have used dashboards (`has_web_dashboards` from pre_checkout), plus owners of the add-on.
 */
export const shouldShowWebDashboardOffer = (
  selfServeEnabled: boolean,
  metadata:
    | { web_dashboard_eligibility?: string | null; has_web_dashboards?: boolean | null }
    | undefined
): boolean =>
  selfServeEnabled &&
  (metadata?.web_dashboard_eligibility === "already_has_addon" ||
    Boolean(metadata?.has_web_dashboards));
